import Debug from 'bloko/common/core/Debug';

export default ({ view, ...props }: { view: string }): void => {
    Debug.log('out error', new Error(`Icon props are not valid for "${view}" view`), props);
};
